import actionTypes from '../actionTypes';

export function requestRacesLeaderboard(limit: number, offset: number, raceId: number): any {
  return {
    type: actionTypes.RACES_LEADERBOARD_REQUEST,
    limit,
    offset,
    raceId
  };
}

export function successRacesLeaderboard(payload: any) {
  return {
    type: actionTypes.RACES_LEADERBOARD_SUCCESS,
    payload,
  };
}

export function resetRacesLeaderboard() {
  return {
    type: actionTypes.RACES_LEADERBOARD_RESET,
  };
}

export function racesLeaderboardLoader() {
  return {
    type: actionTypes.RACES_LEADERBOARD_LOADER,
  };
}

export function failRacesLeaderboard(e: any) {
  return {
    type: actionTypes.RACES_LEADERBOARD_FAILURE,
    exception: e,
  };
}
